<template>
  <section style="position:relative" id="section">

    <el-row class="statusRow">
    	<el-button size="medium" type="primary" @click="goback" icon="el-icon-back">返回</el-button>
    	<el-button size="medium" type="primary" @click="batchAddProduct">批量新增</el-button>
      <el-button size="medium" type="primary" @click="addProduct">新增</el-button>
      <!--<el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>-->
      <el-button size="medium" type="info" @click="deleteProduce(false,-1)">删除</el-button>
      <el-input
        @clear="getList"
        @keyup.enter.native="getList"
        ref="input"
        class="search xs24"
        v-model="pdata.kw"
        clearable
        placeholder="请输入渠道名称"
        :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
      ></el-input>
      
     <el-tag type="info">{{chooseProduct.name}}</el-tag>

     <span class="pr-channel-text">共有渠道<span class="pr-channel-num">{{prChannelTotalNum}}</span>个，其中扣量渠道<span class="pr-channel-num">{{prChannelNum}}</span>个。</span>
		
    </el-row>
    <!--列表-->
    
    <el-table
      :data="plist"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="id"
      @selection-change="select"
      class="demo-table"
    >
     <el-table-column type="selection" min-width="30px"></el-table-column>
     
     <el-table-column prop="channel" fixed label="渠道名称" min-width="50px"  align="center"></el-table-column>
     <el-table-column prop="pr" fixed label="扣量比例" min-width="50px" align="center" ></el-table-column>
     <el-table-column prop="media_o" fixed label="扣量mieia_id" min-width="50px" align="center"  ></el-table-column>
     <el-table-column prop="link_o" fixed label="扣量link_id" min-width="50px" align="center"></el-table-column>
     <el-table-column prop="media" fixed label="原始mieia_id" min-width="50px"  align="center"></el-table-column>
     <el-table-column prop="link" fixed label="原始link_id" min-width="50px" align="center" ></el-table-column>
     <el-table-column prop="status" fixed label="操作" min-width="50px" width="150"  align="center">
     		 <template slot-scope="scope">
					      <el-button size="medium" type="primary" @click="editRule(scope.row)">编辑</el-button>
     		 </template>
     </el-table-column>
     
    
    </el-table>
   

    <el-dialog
      :title="isAdd?'添加屏蔽规则':'编辑屏蔽规则'"
      :visible.sync="editDialog"
      top="5vh"
      width="1000px"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="rule" ref="ruleForm" :label-width="formLabelWidth">

        <el-form-item label="扣量规则" prop="rule">
        	<el-row  :gutter="5" style="margin:0;">
        		 <el-col :span="4"><div class="grid-content bg-purple-light"><el-input v-model="rule.channel" :disabled="!isAdd" placeholder="渠道名称"></el-input></div></el-col>
        		 <el-col :span="3"><div class="grid-content bg-purple-light"><el-input v-model="rule.pr" placeholder="扣量比例"></el-input></div></el-col>
        		 <el-col :span="3"><div class="grid-content bg-purple-light"><el-input v-model="rule.media_o" placeholder="扣量mieia_id"></el-input></div></el-col>
        		 <el-col :span="5"><div class="grid-content bg-purple-light"><el-input v-model="rule.link_o" placeholder="扣量link_id"></el-input></div></el-col>
        		 <el-col :span="3"><div class="grid-content bg-purple-light"><el-input v-model="rule.media" placeholder="原始mieia_id"></el-input></div></el-col>
        		 <el-col :span="5"><div class="grid-content bg-purple-light"><el-input v-model="rule.link" placeholder="原始link_id"></el-input></div></el-col>
        	</el-row>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false; ">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
    
    
    <el-dialog title="批量增加" :visible.sync="batchDialog" width="850px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="140px">

				
				<el-upload
				v-if="batchForm.length==0"
			  class="upload-demo"
			  drag
			  :action="url"
				 :headers="headers"
				  :on-success="batchSuccess"
				  name="file"
				  :show-file-list="false"
				 >
			  <i class="el-icon-upload"></i>
			  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			  <div class="el-upload__tip" slot="tip">只能上传csv文件</div>
			</el-upload>
      </el-form>
       
      <el-row :gutter="5" class="yltt" v-if="batchForm.length>0" >
       	<el-col  :span="24">{{batchTips}}</el-col>
       </el-row>
       
       <el-row class="yltt2" v-if="batchForm.length>0">
       	<el-col :span="4" v-for=" it in  ['渠道名称','扣量比例','扣量media_id	','扣量link_id','原始media_id','原始link_id']">{{it}}</el-col>
       </el-row>
       
       <el-row :gutter="5" v-for="item,index in batchForm" class="yllist" :class="'yllist'+index" v-if="batchForm.length>0">
       		<el-col  :span="4" v-for="(citem,idx) in  item">
       				{{citem}}
       		</el-col>	
       		
       </el-row>
      


      <div slot="footer" class="dialog-footer" v-if="batchForm.length>0">
        <el-button @click="batchCalcel">取 消</el-button>
        <el-button type="primary" @click="batchSubmit" v-if="this.batchTips=='导入预览'">确 定</el-button>
       
      </div>
    </el-dialog>
    
  </section>
</template>

<script>
import { rulesAldDetailList, aldbatchAdd, aldStatus, splog, rulesAldEdit ,baseUrl,aldbatchDelete} from "../../api/api";
//import UploadImg from "./uploadImg.vue";

export default {
  components: {
//  UploadImg
  },
  data() {
    return {
      rules: {
        issued_app_id: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
      	index_id:'',
      	kw:'',
      },
      prChannelTotalNum:0,
      prChannelNum:0,
      plist: [],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [], //日志
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText:"请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      },
      imageUrl: "",
      isAdd: false,
      cP: {
        channels: [],
      }, //修改选中的产品状态,批量修改状态
      selectProduct: [], //批量修改选中的产品
      chooseProduct:{name:"",issued_app_id:''},
      IssAppList:[],
      prWidth: 0,
      option: [], //投放位置配置
      rule:{
					"channel":"",
					"pr": "",
			    "media_o": "",
			    "link_o": "",
			    "media": "",
			    "link": ""
			},
			batchDialog:false,
   		batchForm:[],
			batchTips:'导入预览',
			url:baseUrl+"shieldAld/preview",
			headers:{
          'token':this.$cookie.getCookie("login")
      },
      applist:[],
     form: {
      },
    };
  },
  watch: {

  },
  methods: {
  	goback(){
  		this.$router.back(-1)
  	},
  	batchSuccess(response, file, fileList){

  		if(response.code==200){
  			this.batchForm=response.data;
  		}
  		
  		
  	},
  	 //批量增加
  	batchAddProduct(){
  		this.batchDialog=true;
  	},
  	batchCalcel(){
    	this.batchDialog = false;
    	this.batchForm=[];
    	this.batchTips="导入预览"
    },
    batchSubmit(){
   		var p ={
	  		"index_id":this.pdata.index_id,
				"rule":encodeURIComponent(JSON.stringify(this.batchForm))
      };
      aldbatchAdd(p, this.$cookie.getCookie("login")).then(response => {
        if (response.code == 200) {
         	 if(response.data.length>0){
         	 	 
        			this.batchForm=response.data;
        			this.batchTips="以下数据未成功导入";
        			
        			
         	 }
         	 else{
         	 	 this.$message({ message: "导入成功", type: "success" });
         	 	 this.batchDialog = false;
         	 	 this.batchForm=[];
         	 	 this.getList();
         	 }
        }
        else{
        	this.$message.error('导入失败');
        	 
        }
     });
    },
//	addRules(){
//		var o={pr:"",media_o:"",link_o:"",media:"",link:""};
//		this.chooseProduct.rule.push(o);
//	},
//	removeRules(i){
//		this.chooseProduct.rule.splice(i,1); 
//	},
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      rulesAldDetailList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
//      	res.data.rule.forEach((v,i)=>{
//      		v.keyid=i
//      		
//      	})
					this.chooseProduct.issued_app_id =  res.data.issued_app_id;
          this.plist = res.data.rule;

          //统计扣量渠道个数
          this.prChannelTotalNum=this.plist.length || 0;
          this.prChannelNum=0;
          for(let item of this.plist){
            if(parseFloat(item.pr)!=1){
                this.prChannelNum++;
            }
          }
          
        }
      });
    },
    getChannleName(){
    			this.applist = this.$store.applist;
    			if(this.applist&&this.applist.length>0){
								this.applist.forEach((v,i)=>{
							
										if(v.id==this.chooseProduct.issued_app_id){
											this.chooseProduct.name=v.name
										}
								});
    			}
    			else{
    				setTimeout(()=>{
    					this.getChannleName(); 
    				},300)
    				
    			}
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
        this.applist = this.$store.applist;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter(s){
    	this.pText = s == "" ? "请选择产品投放位置" : s;
    	this.pdata.placement = s;
    	this.getList();
    },
    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editRule(d) {
      this.editDialog = true;
      this.rule = d;
      this.isAdd = false;
    },
//  changeStatus(isSingle, s) {
//    if (!isSingle && this.selectProduct.length == 0) {
//      this.$message.error("请先选择需要批量操作的数据");
//      return;
//    }
//    if (isSingle) {
//      this.cP.index_id = s.id;
//      this.cP.status = s.status == 1 ? "0" : "1";
//    } else {
//      this.cP.status = s;
//    }
//
//    if (this.cP.status == 0) {
//      this.cP.log = "禁用产品";
//    } else if (this.cP.status == 1) {
//      this.cP.log = "启用产品";
//    } else if (this.cP.status == -1) {
//      this.cP.log = "删除产品";
//    }
//    aldStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
//      if (res.code == 200) {
//        this.getList();
//        this.$message({ message: this.cP.log + "成功", type: "success" });
//      }
//    });
//  },
    deleteProduce(isSingle,s){
      	if (this.selectProduct.length == 0) {
		        this.$message.error("请先选择需要批量操作的数据");
		        return;
		    }
    	  this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
			    var p={
							"index_id":this.pdata.index_id,
							"channels": this.cP.channels
					}
		    	aldbatchDelete(p, this.$cookie.getCookie("login")).then(res => {
			        	if (res.code == 200) { 
				          this.$message({ message: "删除成功", type: "success" });
				          this.getList();
					      }
				  });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });

    	
    },
    addProduct() {
    	this.rule={
  				"channel":"",
					"pr": "",
			    "media_o": "",
			    "link_o": "",
			    "media": "",
			    "link": ""
			};
      this.editDialog = true;
      this.isAdd = true;
    },
    submit() {
     	var rule=[];
      rule.push(this.rule);

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.isAdd) {
          	var p ={
          		"index_id":this.pdata.index_id,
     					"rule":encodeURIComponent(JSON.stringify(rule))
          	};
            aldbatchAdd(p, this.$cookie.getCookie("login")).then(
              res => {
                if (res.code == 200) {
                	this.$message({
					          message: '添加成功',
					          type: 'success'
					        });
                  this.getList();
                  this.editDialog = false;
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          } else {
//          this.$prompt("请输入编辑原因", "提示", {
//            confirmButtonText: "确定",
//            cancelButtonText: "取消",
//            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
//            inputErrorMessage: "内容不能为空"
//          }).then(({ value }) => {
              //this.chooseProduct.log = value;
              	var p ={
		          	  "index_id":this.pdata.index_id,
		         			"rule":this.rule,
		          	}
              rulesAldEdit(p, this.$cookie.getCookie("login")).then(
                res => {
                  if (res.code == 200) {
                    this.getList();
                    this.$message({
					          message: '编辑成功',
					          type: 'success'
					        });
                    this.editDialog = false;
                  } else {
                    this.$message.error(res.msg);
                  }
                }
              );
//          });
          }
        } else {
          return false;
        }
      });
    },
    select(s) {
      this.selectProduct = s;
      var p = [];
      s.forEach((v, i) => {
        p.push(v.channel)
      });
      this.cP.channels =p;
    },
    openDealy(id) {
      splog(id, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo(s) {
      this.chooseProduct = JSON.parse(JSON.stringify(s));
      delete this.chooseProduct.id;
      this.chooseProduct.path='';
      this.chooseProduct.placement=''
      this.chooseProduct.log = "新增复用产品";
      this.chooseTags = this.chooseProduct.tags.split(",");
    }
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  mounted() {
  	this.pdata.index_id=	 this.$route.params.index_id;
  	
  	
  
    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};
</script>
<style scoped lang="scss">
span.gn{
	color: #20A0FF;
	cursor: pointer;
}
.dialog {
  width: 800px;
}
.size {
  width: 100px;
  text-align: right;
  position: absolute;
  top: 20px;
  left: -100px;
  padding-right: 14px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
}
</style>

<style >
.demo-table .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    min-width: 200px;
    padding: 0 25px;
}
.demo-table .demo-table-expand label {

    color: #99a9bf;
}
.el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
}
.el-upload-list__item {
  line-height: 0;
}
.selectRow {
  min-width:1200px;padding:15px;background: #fff;
}
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.gameIcon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 220px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pageRow {
  min-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  left: 0;
  bottom: -20px;
  z-index: 1000;
}
@media only screen and (max-width: 767px) {
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 100%;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}

.yltt{
	font-size: 24px;
	font-weight: bold;
	margin: 10px 0 5px;
	text-align: center;
}
.yltt2{
	font-size: 18px;
	line-height: 30px;
	color: #666666;
}
.yllist{
	font-size: 14px;
	color: #999999;
	text-align: center;
	line-height: 25px;
}
.yllist0{
	font-size: 18px;
	color: #666666;
	text-align: center;
	line-height: 25px;
}
.pr-channel-text{
    margin-left: 10px;
}
.pr-channel-num{
    color: #409EFF;
    padding: 0px 4px;
    font-weight: 600;
}

</style>


// WEBPACK FOOTER //
// ALDlistDetail.vue?077cc9c1